import { render, staticRenderFns } from "./avaliar-estabelecimento-container.vue?vue&type=template&id=5a61003d&"
import script from "./avaliar-estabelecimento-container.vue?vue&type=script&lang=ts&"
export * from "./avaliar-estabelecimento-container.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/lib/jenkins-hml/workspace/pracessivel-front/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5a61003d')) {
      api.createRecord('5a61003d', component.options)
    } else {
      api.reload('5a61003d', component.options)
    }
    module.hot.accept("./avaliar-estabelecimento-container.vue?vue&type=template&id=5a61003d&", function () {
      api.rerender('5a61003d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/avaliar-estabelecimento/avaliar-estabelecimento-container.vue"
export default component.exports